"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJMenuScene = void 0;
const CGJGeneralMenuScene_1 = require("./CGJGeneralMenuScene");
const KHMenuSpec_1 = require("./KH/Menu/KHMenuSpec");
class CGJMenuScene extends CGJGeneralMenuScene_1.CGJGeneralMenuScene {
    constructor() {
        super("CGJMenuScene");
    }
    onCreate() {
        this.scene.run("KHAudioScene");
        const audio = this.scene.get("KHAudioScene");
        if (audio && !audio.audio) {
            audio.play('Music', true, false);
        }
        return new KHMenuSpec_1.KHMenuSpec("", [
            this.addText(.5, .07, "THE", .12),
            this.addText(.5, .17, "APPEASEMENT", .12),
            this.addText(.5, .27, "OF", .12),
            this.addText(.5, .37, "CYCLUS", .12),
            this.addClickableOption(.5, .62, "Play Easy Game", () => {
                this.startScene("CGJGameScene", { target: 30 });
            }, .08),
            this.addClickableOption(.5, .7, "Play Normal Game", () => {
                this.startScene("CGJGameScene", { target: 50 });
            }, .08),
            this.addClickableOption(.5, .78, "Play Endless Game", () => {
                this.startScene("CGJGameScene", { target: -1 });
            }, .08),
            this.addClickableOption(.5, .86, "How to Play", () => {
                this.startScene("CGJExpositionScene", { idx: 0 });
            }, .08),
            this.addClickableOption(.5, .94, "Credits", () => {
                this.startScene("CGJCreditsScene");
            }, .08),
        ], this.addConditionalBackOption());
    }
}
exports.CGJMenuScene = CGJMenuScene;
